import { Navigate, Outlet, useLocation } from "react-router-dom";
import { LOGGED_IN, NOT_LOGGED_IN } from "../api/constant";
import Layout from "../components/app/Layout";
import { useAuth } from "../context/security/AuthProvider";

const ProtectedRoutes = () => {
  const stateAuth = useAuth();

  const { userStatus } = stateAuth;
  const location = useLocation();
  if (userStatus === LOGGED_IN) {
    return <Layout />;
  } else if (userStatus === NOT_LOGGED_IN) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
};

export default ProtectedRoutes;
